import { GridCellProps, GridColumnProps } from "@progress/kendo-react-grid";
import { ICON_NAMES } from "utils/constant";
import { GridCommandCellMultiple } from "./GridCommandCell";

interface Props {
	onclick?: (props: GridCellProps) => void;
	iconName: string;
	text?: string;
	showConditionValue?: any;
	conditionField?: string;
	alwaysShow?: boolean;
	style?: React.CSSProperties;
	notEqualToValue?: any;
	disabled?: boolean;
	hidden?: boolean;
    title?: string;
	handler?: (
		props: GridCellProps,
	) => Omit<Props, "iconName"> & { iconName?: string };
}

//Refactor this to handle different codition
export const lastColWithBtn = ({
	showDetails = true,
	items = [],
	openDetail,
	width = "50px",
	showDelete = false,
	deleteItem,
	detailIconTitle,
}: {
	showDetails: boolean;
	openDetail?: (props: GridCellProps) => void;
	items?: Props[];
	width?: string;
	showDelete?: boolean;
	deleteItem?: {
		btn: (props: GridCellProps) => void;
		showConditionValue: any;
		conditionField: string;
		style?: React.CSSProperties;
		disabled?: boolean;
	};
	detailIconTitle?: string;
}) => {
	const column: GridColumnProps = {
		field: "",
		title: "",
		width,
		// className: `${CLASSNAME.TableNumeric} no-border`,
		cell: (props) => {
			const arrow = props.expanded ? ICON_NAMES.ArrowUp : ICON_NAMES.ArrowDown;
			let cellItem = [];

			if (showDelete && deleteItem) {
				if (
					props.dataItem[deleteItem?.conditionField] ===
					deleteItem?.showConditionValue
				) {
					cellItem.push({
						onclick: deleteItem.btn,
						iconName: ICON_NAMES.Delete,
						style: deleteItem.style,
						disabled: deleteItem.disabled,
					});
				}
			}
			items.forEach((item) => {
				if (item.handler) {
					item = {
						...item,
						...item.handler(props),
					};
				}

				if (item.hidden) {
					return;
				}

				if (item.alwaysShow) {
					cellItem.push({
						onclick: item.onclick,
						iconName: item.iconName,
						style: item.style,
						disabled: item?.disabled,
						title: item?.title,
						text: item?.text,
					});
				} else if (item.notEqualToValue) {
					if (
						props.dataItem[item.conditionField as any] !== item.notEqualToValue
					) {
						cellItem.push({
							onclick: item.onclick,
							iconName: item.iconName,
							style: item.style,
							disabled: item?.disabled,
							title: item?.title,
							text: item?.text,
						});
					}
				} else if (
					props.dataItem[item.conditionField as any] === item.showConditionValue
				) {
					cellItem.push({
						onclick: item.onclick,
						iconName: item.iconName,
						style: item.style,
						disabled: item?.disabled,
						title: item?.title,
						text: item?.text,
					});
				}
			});
			if (showDetails) {
				cellItem.push({ onclick: openDetail, iconName: arrow, title: detailIconTitle });
			}
			return <GridCommandCellMultiple {...props} items={cellItem} />;
		},
	};
	return column;
};
